import React, { useState } from "react";
import { SketchPicker } from "react-color";
import "./Legend.css"; // Ensure you have a corresponding CSS file for styling

const Legend = ({ chartConfig, setChartConfig }) => {
  const [showTextColorPicker, setShowTextColorPicker] = useState(false);

  const handleChangeLegend = (key, value) => {
    setChartConfig((prevConfig) => ({
      ...prevConfig,
      legend: { ...prevConfig.legend, [key]: value }
    }));
  };

  return (
    <div className="legend-settings-container">
      <h3>Legend Settings</h3>

      {/* Show Legend */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Show Legend</label>
        <input
          type="checkbox"
          checked={chartConfig?.legend?.show || false}
          onChange={(e) => handleChangeLegend("show", e.target.checked)}
        />
      </div>

      {/* Show for Single Series */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Show for Single Series</label>
        <input
          type="checkbox"
          checked={chartConfig?.legend?.showForSingleSeries || false}
          onChange={(e) => handleChangeLegend("showForSingleSeries", e.target.checked)}
        />
      </div>

      {/* Floating Legend */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Floating Legend</label>
        <input
          type="checkbox"
          checked={chartConfig?.legend?.floating || false}
          onChange={(e) => handleChangeLegend("floating", e.target.checked)}
        />
      </div>

      {/* Position */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Position</label>
        <select
          value={chartConfig?.legend?.position || "bottom"}
          onChange={(e) => handleChangeLegend("position", e.target.value)}
        >
          <option value="top">Top</option>
          <option value="bottom">Bottom</option>
          <option value="left">Left</option>
          <option value="right">Right</option>
        </select>
      </div>

      {/* Horizontal Position */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Horizontal Position</label>
        <select
          value={chartConfig?.legend?.horizontalAlign || "left"}
          onChange={(e) => handleChangeLegend("horizontalAlign", e.target.value)}
        >
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>

      {/* Left Offset */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Left Offset</label>
        <input
          type="number"
          value={chartConfig?.legend?.offsetX || 0}
          onChange={(e) => handleChangeLegend("offsetX", Number(e.target.value))}
        />
      </div>

      {/* Top Offset */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Top Offset</label>
        <input
          type="number"
          value={chartConfig?.legend?.offsetY || 0}
          onChange={(e) => handleChangeLegend("offsetY", Number(e.target.value))}
        />
      </div>

      {/* Horizontal Spacing */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Horizontal Spacing</label>
        <input
          type="number"
          value={chartConfig?.legend?.itemMargin?.horizontal || 10}
          onChange={(e) =>
            handleChangeLegend("itemMargin", {
              ...chartConfig?.legend?.itemMargin,
              horizontal: Number(e.target.value)
            })
          }
        />
      </div>

      {/* Vertical Spacing */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Vertical Spacing</label>
        <input
          type="number"
          value={chartConfig?.legend?.itemMargin?.vertical || 10}
          onChange={(e) =>
            handleChangeLegend("itemMargin", {
              ...chartConfig?.legend?.itemMargin,
              vertical: Number(e.target.value)
            })
          }
        />
      </div>

      {/* Font Size */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Font Size</label>
        <input
          type="number"
          value={chartConfig?.legend?.fontSize || 14}
          onChange={(e) => handleChangeLegend("fontSize", Number(e.target.value))}
        />
      </div>

      {/* Font Weight */}
      <div className="legend-settings-section">
        <label className="legend-settings-label">Font Weight</label>
        <select
          value={chartConfig?.legend?.fontWeight || "normal"}
          onChange={(e) => handleChangeLegend("fontWeight", e.target.value)}
        >
          <option value="normal">Normal</option>
          <option value="bold">Bold</option>
        </select>
      </div>

      {/* Text Color */}
      <div className="color-picker-wrapper">
        <label className="legend-settings-label">Text Color</label>
        <button className="color-picker-button" onClick={() => setShowTextColorPicker(!showTextColorPicker)}>
          <div
            className="color-swatch"
            style={{
              backgroundColor: chartConfig?.legend?.style?.color || "#000000"
            }}
          />
        </button>
        {showTextColorPicker && (
          <div className="picker-popover">
            <div className="picker-cover" onClick={() => setShowTextColorPicker(false)} />
            <SketchPicker
              color={chartConfig?.legend?.style?.color || "#000000"}
              onChangeComplete={(color) =>
                handleChangeLegend("style", {
                  ...chartConfig?.legend?.style,
                  color: color.hex
                })
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Legend;
